import api from "../services/api";

// Get dashboard analytics
export const getDashboardAnalytics = async (days = 7) => {
  return api.get("/api/dashboard/analytics", {
    params: { days },
  });
};

